module.exports = __webpack_public_path__ + "static/media/fale-conosco-email.2bfcd7a5.png";